import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import H5 from '@base/H5/H5';
import P1 from '@base/P1/P1';
import { Spacings } from '@styles/index';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${Spacings.SPACING_10B};
`;

const Title = styled(H5)`
  margin-bottom: ${Spacings.SPACING_2B};
`;

const StyledUl = styled.ul`
  list-style: none;
  padding-left: 0px;
`;

const StyledP1 = styled(P1)`
  margin-top: ${Spacings.SPACING_2B};
  color: var(--color-i-blue);
  display: inline-block;
`;

const ContentsTable = ({ data }) => {
  return (
    <Container>
      <Title>Table of contents :</Title>
      <StyledUl>
        {data.map((dataItem, index) => {
          const { label, id } = dataItem;
          return (
            <li key={String(index)}>
              <a href={`#${id}`}>
                <StyledP1>{label}</StyledP1>
              </a>
            </li>
          );
        })}
      </StyledUl>
    </Container>
  );
};

ContentsTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired
};

export default ContentsTable;
